module.exports = __webpack_public_path__ + "img/findland.874e5f6d.svg";